import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Palette } from "lucide-react";

const CustomDesignSection = ({ image }) => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="home-custom-design">
    <div className="grid overflow-hidden rounded-[8px] border border-white/10 bg-cynos-card md:grid-cols-[1.05fr_0.95fr]">
      <div className="relative min-h-[280px] overflow-hidden md:min-h-[440px]">
        <img src={image} alt="Custom printed streetwear design" className="absolute inset-0 h-full w-full object-cover zoom-on-hover" loading="lazy" decoding="async" sizes="(max-width: 768px) 100vw, 52vw" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 p-5 md:p-8">
          <div className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">Made For You</div>
          <div className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">Custom Drops.</div>
        </div>
      </div>

      <div className="flex flex-col justify-center p-5 md:p-8 lg:p-10">
        <div className="inline-flex h-12 w-12 items-center justify-center border border-cynos-red/40 bg-cynos-red/10 text-cynos-red">
          <Palette size={22} />
        </div>
        <h2 className="mt-5 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">
          Your artwork. Our tee.
        </h2>
        <p className="mt-4 max-w-lg text-sm leading-6 text-zinc-400">
          Send your print idea, reference artwork, preferred product type, size, and budget. We will review the brief and help turn it into a Cynos-ready piece.
        </p>
        <div className="mt-5 grid gap-2 font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-400 sm:grid-cols-3 md:gap-3">
          <span className="border border-white/10 bg-black/40 px-4 py-3">Artwork Upload</span>
          <span className="border border-white/10 bg-black/40 px-4 py-3">Budget Optional</span>
          <span className="border border-white/10 bg-black/40 px-4 py-3">Team Review</span>
        </div>
        <Link to="/custom-design" className="mt-6 inline-flex min-h-[50px] w-fit items-center gap-2 rounded-[8px] bg-cynos-red px-6 py-4 font-mono text-[11px] uppercase tracking-[0.18em] text-white transition hover:bg-red-600 md:text-xs" data-testid="home-custom-design-link">
          Start Custom Request <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  </section>
);

export default CustomDesignSection;
